export default __webpack_public_path__ + "static/media/NewYearResolution_05.3e2708e2.png";